import type { GenericObjectType } from '@/types';

/**
 * Function to check whether the selected country is present
 * in the provided list or not
 * @param matchKey -> desired property from the list that needs to be matched
 * against the value eg: obj.value, obj.code, etc
 * @param selectedCountryVal -> country to be validated for
 * @param countryList -> source object containng list of countries
 * @returns boolean whether the selected country is present in the given list
 */
export const isValidCountrySelection = <T extends GenericObjectType[]>(
  matchKey: keyof T[number],
  selectedCountryVal: string,
  countryList: T,
): boolean => {
  return countryList?.some(
    countryObj => countryObj[matchKey] === selectedCountryVal,
  );
};
